export default {
}



// WEBPACK FOOTER //
// src/store/authen/password/getters.js